import { render, staticRenderFns } from "./time.vue?vue&type=template&id=624543c0&scoped=true"
import script from "./time.vue?vue&type=script&lang=js"
export * from "./time.vue?vue&type=script&lang=js"
import style0 from "./time.vue?vue&type=style&index=0&id=624543c0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624543c0",
  null
  
)

export default component.exports